import React, { useState, useEffect } from "react";
import { Form, Input, Button, message } from "antd";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import styles from "../../../styles/Components/mini-app/auth/MiniAppLoginPage.module.css";
import { CognitoUser } from "amazon-cognito-identity-js";
import { checkEmailException } from "../../../utility/helper";
import PoolData from "../../../pages/Auth/AWSConfig/PoolData";
import { MdEmail } from "react-icons/md";
import { TfiEmail } from "react-icons/tfi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { notify } from "../../../utility/Toastify/toastify";

const emailValidationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
});

const codeValidationSchema = Yup.object({
  code: Yup.string().required("Confirmation code is required"),
});

function MiniAppResendConfirmationCode({ setAuthType }) {
  const [step, setStep] = useState(1);
  const [countdown, setCountdown] = useState(0);
  const [email, setEmail] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(
      step === 1 ? emailValidationSchema : codeValidationSchema,
    ),
  });

  const resetTimer = () => setCountdown(20);

  const resendCodeHandler = (email) => {
    setLoading(true);
    const getUser = () => {
      return new CognitoUser({
        Username: checkEmailException(email),
        Pool: PoolData,
      });
    };

    const onSuccess = (data) => {
      setLoading(false);
      setStep(2);
      resetTimer();
    };
    const onFailure = (err) => {
      message.error(err.message || JSON.stringify(err));
      setLoading(false);
    };

    getUser().resendConfirmationCode((err, data) => {
      if (err) {
        onFailure(err);
      } else {
        onSuccess(data);
      }
    });
  };

  const confirmAccount = (code) => {
    setLoading(true);
    const userData = {
      Username: email.toLowerCase(),
      Pool: PoolData,
    };
    const cognitoUser = new CognitoUser(userData);

    return new Promise((resolve, reject) => {
      cognitoUser.confirmRegistration(code, true, function (err, result) {
        setLoading(false);
        if (err?.message?.includes("CONFIRMED")) {
          notify(
            "Your account has already been confirmed. Please login.",
            "info",
          );
          if (setAuthType) {
            setAuthType("login");
          }
          return navigate("/mini-login");
        }
        if (err) {
          message.error(err?.message);
          reject(err);
        } else {
          message.success("Your email successfully confirmed.");
          resolve(result);
          if (setAuthType) {
            setAuthType("login");
          } else {
            navigate("/mini-login");
          }
        }
      });
    });
  };

  const onSubmit = (data) => {
    console.log(data);
    if (loading) return;
    if (step === 1) {
      // Handle email submission
      resendCodeHandler(data?.email);
      setEmail(data?.email);
    } else {
      // Handle code submission
      confirmAccount(data?.code);
    }
  };

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  return (
    <div style={!setAuthType ? { padding: "1rem 1rem 0" } : {}}>
      {step === 1 ? (
        <h4 className={styles.title}>
          <span>Confirm</span> <br />
          Your Account
        </h4>
      ) : (
        <h4 className={styles.title}>
          <span>Confirmation</span> <br />
          Code
        </h4>
      )}
      <Form onFinish={handleSubmit(onSubmit)}>
        {step === 1 && (
          <Form.Item
            validateStatus={errors.email ? "error" : ""}
            help={errors.email?.message}
            className={styles.formItem}
          >
            <Controller
              name="email"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <div className={styles.inputWrapper}>
                  <TfiEmail color="#454545" />
                  <Input {...field} placeholder="Enter your email" />
                </div>
              )}
            />
          </Form.Item>
        )}
        {step === 2 && (
          <Form.Item
            validateStatus={errors.code ? "error" : ""}
            help={errors.code?.message}
            className={styles.formItem}
          >
            <Controller
              name="code"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <div className={styles.inputWrapper}>
                  <FaRegCircleCheck color="#454545" />
                  <Input {...field} placeholder="Enter confirmation code" />
                </div>
              )}
            />
          </Form.Item>
        )}
        <Form.Item style={{ textAlign: "center", marginTop: "1rem" }}>
          <Button
            type="primary"
            htmlType="submit"
            // disabled={step === 2 && countdown > 0}
            className={styles.submitBtn}
            loading={loading}
          >
            {step === 1 ? "Submit" : "Confirm"}
            {/*{step === 1 ? (*/}
            {/*  "Submit"*/}
            {/*) : countdown > 0 ? (*/}
            {/*  <>*/}
            {/*    Submit{" "}*/}
            {/*    <span style={{ fontSize: "12px" }}>*/}
            {/*      ()*/}
            {/*    </span>*/}
            {/*  </>*/}
            {/*) : (*/}
            {/*  "Submit"*/}
            {/*)}*/}
          </Button>
        </Form.Item>
        {step === 2 && (
          <div style={{ textAlign: "center" }}>
            {countdown > 0 ? (
              `Request a new code in ${countdown}s.`
            ) : (
              <span
                className={styles.resendCodeBtn}
                onClick={() => resendCodeHandler(email)}
              >
                Resend Code
              </span>
            )}
          </div>
        )}

        {step === 2 && (
          <div className={styles.spamHint}>
            <MdEmail className={styles.spamHintIcon} />
            Didn’t receive the code? Check your spam folder.
          </div>
        )}
        <p
          className={styles.createAccountBtn}
          onClick={() => {
            if (!setAuthType) {
              navigate("/mini-login");
            } else {
              setAuthType("login");
            }
          }}
        >
          Go to Login
        </p>
      </Form>
    </div>
  );
}

export default MiniAppResendConfirmationCode;
